import React from 'react';
import { Link } from 'react-router-dom';
import Tippy from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import { formatNumber, getObjectStatus } from '../helpers/helpers';
import 'tippy.js/dist/tippy.css';
import './ObjectItem.scss';

export function ObjectTooltip(props) {
  const { itemData } = props;
  const price = itemData.price ? formatNumber(itemData.price) : null;
  const fee = itemData.monthlyFee ? formatNumber(itemData.monthlyFee) : null;
  const status = itemData.status ? getObjectStatus(itemData.status) : null;
  return (
    <div className="ObjectTooltip" data-testid="object-item-tooltip">
      <h3>{itemData.apartmentNumber}</h3>
      <p>
        Status: <strong>{status}</strong>
        <br />
        Antal rum: <strong>{itemData.rooms} rum & kök</strong>
        <br />
        Pris: <strong>{price ? `${price} SEK` : '-'}</strong>
        <br />
        Avgift: <strong>{fee ? `${fee} SEK` : '-'}</strong>
        <br />
        Storlek: <strong>{itemData.size} m²</strong>
        <br />
        Våning: <strong>{itemData.floor}</strong>
      </p>
    </div>
  );
}

export default function ObjectItem(props) {
  const {
    name,
    attributes,
    itemData,
    handleActiceObject,
    activeObjectId,
  } = props;

  if (!itemData) {
    return null;
  }

  const status = getObjectStatus(itemData.status);
  let classes = attributes.class || '';

  if (status === 'Till salu') {
    classes += ' for-sale';
  } else if (status === 'Intagen') {
    classes += ' sold-not-admitted';
  } else if (status === 'Bokad') {
    classes += ' reserved';
  } else if (status === 'Såld') {
    classes += ' sold';
  }

  if (activeObjectId === itemData.id) {
    classes += ' active';
  }

  if (name === 'path') {
    return (
      <Tippy
        trigger="mouseenter"
        content={<ObjectTooltip data-test="" itemData={itemData} />}
        theme="kvartetten"
        followCursor={true}
        plugins={[followCursor]}
      >
        <Link to={`/objekt/${itemData.id}`} data-testid="object-link">
          <path
            id={attributes.id}
            className={classes}
            d={attributes.d}
            data-name={attributes['data-name']}
            data-testid="object-item-svg"
            onMouseEnter={() => {
              handleActiceObject(itemData.id);
            }}
            onMouseLeave={() => {
              handleActiceObject(null);
            }}
          ></path>
        </Link>
      </Tippy>
    );
  } else if (name === 'polygon') {
    return (
      <Tippy
        trigger="mouseenter"
        content={<ObjectTooltip data-test="" itemData={itemData} />}
      >
        <Link to={`/objekt/${itemData.id}`} data-testid="object-link">
          <polygon
            id={attributes.id}
            className={classes}
            points={attributes.points}
            data-testid="object-item-svg"
          ></polygon>
        </Link>
      </Tippy>
    );
  }
  if (name === 'rect') {
    return (
      <Tippy
        trigger="mouseenter"
        content={<ObjectTooltip itemData={itemData} />}
      >
        <Link to={`/objekt/${itemData.id}`} data-testid="object-link">
          <rect
            id={attributes.id}
            className={classes}
            height={attributes.height}
            width={attributes.width}
            x={attributes.x}
            y={attributes.y}
            data-testid="object-item-svg"
          ></rect>
        </Link>
      </Tippy>
    );
  } else if (name === 'path') {
    return null; // At the moment we do not support path, might be needed in the future
  } else if (name === 'defs') {
    return null;
  } else {
    return null;
  }
}
